import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import onClick from '@123/druid/dist/Framework/Decorators/OnClick';
import prop from '@123/druid/dist/Framework/Decorators/Prop';
import View from '@123/druid/dist/Framework/View/View';
import CookieService from '@Service/Cookie/CookieService';

@component
export default class EmergencyNotificationView extends View {
    @prop('string') private hash?: string;

    constructor(@inject(CookieService) private readonly cookieService: CookieService) {
        super();
    }

    @onClick('close-button')
    protected async closeNotification(): Promise<void> {
        if (this.hash === undefined) {
            throw new Error('Emergency notification cannot be processed: hash is missing');
        }

        await this.cookieService.setCookie({name: 'EmergencyNotification', value: this.hash});

        this.el.remove();
    }
}
